<div>
  <span *ngFor="let item of selectedItems;" class="selected-items">
    <span *ngIf="item?.description" class="info">
      <span class="item-info description">{{item.description}}</span>
    </span>
  </span>
</div>
<a (click)="showDataToIncludeForm()" class="popup-open-button operation ui-btn button-styled">{{btnTitle}}</a>

